function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1-error-online",
  d: "M280.5,440.88h33a8,8,0,0,1,0,16h-33a8,8,0,0,1,0-16Z",
  transform: "translate(-270 -385.5)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M287.59,449.33a5.28,5.28,0,0,1-.42,2.19,3.2,3.2,0,0,1-1.2,1.43,3.3,3.3,0,0,1-4.8-1.42,5.06,5.06,0,0,1-.44-2.12v-.62a5.21,5.21,0,0,1,.43-2.17,3.16,3.16,0,0,1,3-1.95,3.31,3.31,0,0,1,1.81.5,3.19,3.19,0,0,1,1.2,1.44,5.3,5.3,0,0,1,.42,2.19Zm-1.12-.55a3.83,3.83,0,0,0-.61-2.33,2,2,0,0,0-1.71-.81,2,2,0,0,0-1.68.81,3.75,3.75,0,0,0-.63,2.25v.63a3.83,3.83,0,0,0,.62,2.31,2.17,2.17,0,0,0,3.39,0,3.81,3.81,0,0,0,.62-2.28Z",
  transform: "translate(-270 -385.5)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M290.13,447l0,.8a2.31,2.31,0,0,1,1.9-.91q2,0,2,2.27v4.19H293v-4.2a1.46,1.46,0,0,0-.31-1,1.26,1.26,0,0,0-1-.33,1.56,1.56,0,0,0-.93.28,1.91,1.91,0,0,0-.62.74v4.52H289.1V447Z",
  transform: "translate(-270 -385.5)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M296.9,453.32h-1.08v-9h1.08Z",
  transform: "translate(-270 -385.5)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M298.64,445.29a.65.65,0,0,1,.16-.45.6.6,0,0,1,.48-.18.61.61,0,0,1,.48.18.64.64,0,0,1,.16.45.62.62,0,0,1-.16.44.63.63,0,0,1-.48.18.62.62,0,0,1-.48-.18A.63.63,0,0,1,298.64,445.29Zm1.17,8h-1.08V447h1.08Z",
  transform: "translate(-270 -385.5)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M302.58,447l0,.8a2.31,2.31,0,0,1,1.9-.91q2,0,2,2.27v4.19h-1.08v-4.2a1.46,1.46,0,0,0-.31-1,1.26,1.26,0,0,0-1-.33,1.56,1.56,0,0,0-.93.28,1.91,1.91,0,0,0-.62.74v4.52h-1.08V447Z",
  transform: "translate(-270 -385.5)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2-error-online",
  d: "M310.8,453.43a2.77,2.77,0,0,1-2.1-.85,3.14,3.14,0,0,1-.81-2.26v-.2a3.8,3.8,0,0,1,.36-1.68,2.81,2.81,0,0,1,1-1.16,2.53,2.53,0,0,1,1.4-.42,2.37,2.37,0,0,1,1.92.81,3.53,3.53,0,0,1,.69,2.33v.45H309a2.25,2.25,0,0,0,.55,1.51,1.72,1.72,0,0,0,1.33.58,1.89,1.89,0,0,0,1-.23,2.44,2.44,0,0,0,.7-.62l.66.52A2.66,2.66,0,0,1,310.8,453.43Zm-.13-5.68a1.45,1.45,0,0,0-1.1.48,2.32,2.32,0,0,0-.55,1.34h3.18v-.08a2.06,2.06,0,0,0-.45-1.28A1.36,1.36,0,0,0,310.67,447.75Z",
  transform: "translate(-270 -385.5)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3-error-online",
  d: "M318,385.5H276a6,6,0,0,0-6,6v35a6,6,0,0,0,6,6h42a6,6,0,0,0,6-6v-35A6,6,0,0,0,318,385.5Zm-1,44H277a4,4,0,0,1-4-4v-33a4,4,0,0,1,4-4H317a4,4,0,0,1,4,4v33A4,4,0,0,1,317,429.51Zm-3.47,5h-32a1.5,1.5,0,0,0,0,3h32a1.5,1.5,0,0,0,0-3Z",
  transform: "translate(-270 -385.5)"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  className: "cls-4-error-online"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3-error-online",
  d: "M289,416l8,.94V410h-8Zm0-7h8v-6.94l-8,.94Zm9-7.06V409h8v-8Zm0,15.12,8,.94v-8h-8Z",
  transform: "translate(-270 -385.5)"
}));

var SvgErrorOnline = function SvgErrorOnline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "error_online_computer",
    "data-name": "Layer 1",
    viewBox: "0 0 54 71.38",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorOnline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error_online.972373d9.svg";
export { ForwardRef as ReactComponent };